
const Food = [
    // Mexican Food
    {
        id: 1001,
        url: require("../component/Dashboard/image/mexicanfood.jpg"),
        rate: '120',
        title: 'Tacos',
        quantity: '3 pieces',
        star: 4.5,
        description: 'Classic Mexican tacos with beef, lettuce, cheese, and salsa.',
        titlename: 'MexicanFood',
        titleId: 1001
    },
    {
        id: 1002,
        url: require("../component/Dashboard/image/mexicanfood.jpg"),
        rate: '150',
        title: 'Burrito',
        quantity: '1 large',
        star: 4.7,
        description: 'Flour tortilla filled with beans, rice, chicken, and veggies.',
        titlename: 'MexicanFood',
        titleId: 1001
    },
    // Chinese Food
    {
        id: 2001,
        url: require("../component/Dashboard/image/chinesefood.jpg"),
        rate: '110',
        title: 'Chow Mein',
        quantity: '1 plate',
        star: 4.6,
        description: 'Stir-fried noodles with vegetables and chicken.',
        titlename: 'ChineseFood',
        titleId: 2001
    },
    {
        id: 2002,
        url: require("../component/Dashboard/image/chinesefood.jpg"),
        rate: '130',
        title: 'Spring Rolls',
        quantity: '4 pieces',
        star: 4.3,
        description: 'Crispy rolls stuffed with veggies and served with sweet chili sauce.',
        titlename: 'ChineseFood',
        titleId: 2001
    },
    // American Food
    {
        id: 3001,
        url: require("../component/Dashboard/image/americanfood.jpg"),
        rate: '140',
        title: 'Burger',
        quantity: '1 piece',
        star: 4.8,
        description: 'Juicy beef burger with cheese, lettuce, and tomato.',
        titlename: 'AmericanFood',
        titleId: 3001
    },
    {
        id: 3002,
        url: require("../component/Dashboard/image/americanfood.jpg"),
        rate: '90',
        title: 'Fries',
        quantity: '1 plate',
        star: 4.2,
        description: 'Crispy golden fries served with ketchup.',
        titlename: 'AmericanFood',
        titleId: 3001
    },
    // Thai Food
    {
        id: 4001,
        url: require("../component/Dashboard/image/thaifood.jpg"),
        rate: '160',
        title: 'Pad Thai',
        quantity: '1 plate',
        star: 4.7,
        description: 'Rice noodles stir-fried with shrimp, tofu, peanuts, and bean sprouts.',
        titlename: 'ThaiFood',
        titleId: 4001
    },
    {
        id: 4002,
        url: require("../component/Dashboard/image/thaifood.jpg"),
        rate: '120',
        title: 'Green Curry',
        quantity: '1 bowl',
        star: 4.5,
        description: 'Spicy Thai green curry with chicken and vegetables.',
        titlename: 'ThaiFood',
        titleId: 4001
    },
    {
        id: 1,
        url: require("../component/Dashboard/image/Indfood-1.jpg"),
        rate: '50',
        title: 'Idly',
        quantity: '2 pieces',
        star: 4.5,
        description: 'Idli are a type of savoury rice cake, originating from the Indian subcontinent, popular as breakfast foods in Southern India and in Sri Lanka. The cakes are made by steaming a batter consisting of fermented white gram whole and rice rava. and dipped into sambar. its also called as dip sambar idli.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 2,
        url: require("../component/Dashboard/image/Indfood-2.jpg"),
        rate: '100',
        title: 'Dosa',
        quantity: '2 pieces',
        star: 4.5,
        description: 'A thin and crispy pancake prepared with fermented dosa batter which is topped with red garlic chutney and potato masala. the appearance and texture is very similar to world famous masala dosa. but the main difference lies with the red garlic chutney spread topped on bangalore dosa.',
        fakerate: 900,
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 3,
        url: require("../component/Dashboard/image/Indfood-3.jpg"),
        rate: '100',
        title: 'Puri',
        quantity: '2 pieces',
        star: 4.5,
        description: 'South Indian style potato masala made with boiled, crumbled potatoes in mild, flavorful gravy. It is served with hot Poori which is a deep-fried bread made from unleavened whole-wheat flour',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 4,
        url: require("../component/Dashboard/image/Indfood-4.jpg"),
        rate: '100',
        title: 'Upma',
        quantity: '1 Serve',
        star: 3,
        description: "The best aromatic upma topped with vegetables and ghee and it comes with more vegetables. Staying consious of one's health is the way to go, thus is a light upma made of wheat grains and vegetable ",
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 5,
        url: require("../component/Dashboard/image/Indfood-5.jpg"),
        rate: '100',
        title: 'Chappathi',
        quantity: '2 pieces',
        star: 5,
        description: 'Traditional whole wheat Tawa special,What are the few lines for chapati Chapati is Indian flat bread made of wheat flour. It is the staple food in the North Asian countries especially in North India and Pakistan. It can also be made of various other flours like the jowar, bajra, soya, raji etc.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 6,
        url: require("../component/Dashboard/image/Indfood-6.jpg"),
        rate: '100',
        title: 'Biriyani',
        quantity: '1 Serve',
        star: 4,
        description: 'Rich in taste and creamy in texture. Think we are talking about a dessert? Well,this biryani might as well be one with the way it melts in your mouth. Tender chicken is marinated in yogurt&spices to make this biryani delicious',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 7,
        url: require("../component/Dashboard/image/Indfood-7.jpg"),
        rate: '100',
        title: 'Fish fry',
        quantity: '2 pieces',
        star: 5,
        description: 'Fish fry is cooked by coating it with flours and spices which adds crispness and spiciness.fish battered and fried with authentic andra spices. And served in a traditional south Indian masala - Served with Res Chutni & Onion Salad',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 8,
        url: require("../component/Dashboard/image/Indfood-8.jpg"),
        rate: '100',
        title: 'Crab',
        quantity: '2 pieces',
        star: 4.5,
        description: 'Singapore style chili pepper fried soft shell crab served with jasmine rice. Hand picked crab prepared with traditional spices',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 9,
        url: require("../component/Dashboard/image/Indfood-9.jpg"),
        rate: '100',
        title: 'Prawn',
        quantity: '6 pieces',
        star: 5,
        description: 'King prawns stir fried in a  hunan style soy-chilli sause with fresh chillies,lemongrass,kaffir lime leaves,shallots,onion and celery',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 10,
        url: require("../component/Dashboard/image/Indfood-10.jpg"),
        rate: '100',
        title: 'Pav baaji',
        quantity: '2 pieces',
        star: 5,
        description: 'Pav Bhaji is a fast food dish from Mumbai (Bombay), India, consisting of a vegetable curry (bhaji) cooked in tomato gravy and served with a soft bread roll (pav).',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 11,
        url: require("../component/Dashboard/image/Indfood-11.png"),
        rate: '100',
        title: 'Parotta',
        quantity: '3 pieces',
        star: 5,
        description: 'Parotta or Porotta is a layered Indian and Sri Lankan flatbread made from Maida or Atta, alternatively known as flaky ribbon pancake.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 12,
        url: require("../component/Dashboard/image/indfood-12.png"),
        rate: '100',
        title: 'Veg meals',
        quantity: '1 Serve',
        star: 5,
        description: 'A vegetarian diet does not include any meat, poultry, or seafood. It is a meal plan made up of foods that come mostly from plants',
        titlename: 'IndianFood',
        titleId: 1
    },

    // Add new items here
    {
        id: 14, // Unique ID
        url: require("../component/Dashboard/image/paneer-tikka.png"), // Path to new image
        rate: '200',
        title: 'Paneer Tikka',
        quantity: '300g',
        star: 4,
        description: 'Grilled paneer cheese with spices and vegetables, a popular Indian appetizer.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 15, // Unique ID
        url: require("../component/Dashboard/image/biryani.png"), // Path to new image
        rate: '300',
        title: 'Biryani',
        quantity: '600g',
        star: 5,
        description: 'Aromatic rice dish with spices, vegetables, and optional meat, a classic Indian delicacy.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 16,
        url: require("../component/Dashboard/image/butter-chicken.png"),
        rate: '250',
        title: 'Butter Chicken',
        quantity: '500g',
        star: 5,
        description: 'Creamy tomato-based curry with tender chicken, a North Indian favorite.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 17,
        url: require("../component/Dashboard/image/chole-bhature.png"),
        rate: '150',
        title: 'Chole Bhature',
        quantity: '2 Pieces',
        star: 4,
        description: 'Spicy chickpea curry served with fluffy deep-fried bread.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 18,
        url: require("../component/Dashboard/image/dal-tadka.png"),
        rate: '120',
        title: 'Dal Tadka',
        quantity: '400g',
        star: 4,
        description: 'Yellow lentils tempered with spices, a comforting Indian staple.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 19,
        url: require("../component/Dashboard/image/masala-dosa.png"),
        rate: '100',
        title: 'Masala Dosa',
        quantity: '1 Piece',
        star: 5,
        description: 'Crispy rice pancake filled with spiced potato filling, served with chutney.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 20,
        url: require("../component/Dashboard/image/palak-paneer.png"),
        rate: '180',
        title: 'Palak Paneer',
        quantity: '400g',
        star: 4,
        description: 'Paneer cubes in a creamy spinach gravy, a popular vegetarian dish.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 21,
        url: require("../component/Dashboard/image/rogan-josh.png"),
        rate: '280',
        title: 'Rogan Josh',
        quantity: '500g',
        star: 5,
        description: 'Aromatic lamb curry with a rich, spiced yogurt-based sauce.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 22,
        url: require("../component/Dashboard/image/idli-sambar.png"),
        rate: '80',
        title: 'Idli Sambar',
        quantity: '4 Pieces',
        star: 4,
        description: 'Steamed rice cakes served with lentil-based sambar and chutney.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 23,
        url: require("../component/Dashboard/image/naan.png"),
        rate: '50',
        title: 'Naan',
        quantity: '1 Piece',
        star: 4,
        description: 'Soft and fluffy Indian flatbread baked in a tandoor.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 24,
        url: require("../component/Dashboard/image/samosa.png"),
        rate: '60',
        title: 'Samosa',
        quantity: '2 Pieces',
        star: 5,
        description: 'Crispy pastry filled with spiced potatoes and peas, a popular snack.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 25,
        url: require("../component/Dashboard/image/malai-kofta.png"),
        rate: '220',
        title: 'Malai Kofta',
        quantity: '400g',
        star: 4,
        description: 'Creamy kofta balls in a rich tomato and cashew gravy.',
        titlename: 'IndianFood',
        titleId: 1
    },
    {
        id: 2.1,
        url: require("../component/Dashboard/image/Italifood-1.jpg"),
        rate: '300',
        title: 'Spaghetti',
        quantity: '2 pieces',
        star: 4.5,
        titlename: 'ItalianFood',
        titleId: 2,
        description: 'Spaghetti is a long, thin, solid, cylindrical noodle pasta. Like other pasta, spaghetti is made of milled wheat and water and sometimes enriched with vitamins and minerals. Italian dried spaghetti is made from durum wheat semolina, however; outside of Italy, it can be made in a variety of different ways.'
    },
    {
        id: 2.2,
        url: require("../component/Dashboard/image/italifood-2.jpg"),
        rate: '250',
        title: 'Lasagna',
        quantity: '1 Serve',
        star: 4.5,
        titlename: 'ItalianFood',
        titleId: 2,
        description: 'Lasagna is a flat and expanded pasta sheet, traditionally made in Italy with Parmigiano-Reggiano (Parmesan cheese), Béchamel sauce (white sauce), and ragù (a meat-based sauce).'
    },
    {
        id: 2.3,
        url: require("../component/Dashboard/image/italifood-3.jpg"),
        rate: '500',
        title: ' Risotto milanese',
        quantity: '1 serve',
        star: 5,
        titlename: 'ItalianFood',
        titleId: 2,
        description: 'A classic risotto is a rich, creamy dish with nearly a porridge-like consistency, yet each grain of rice retains a distinct bite. In Italian risotto, the rice is parched as in the pilaf method, but the liquid is added and absorbed gradually while the grain is stirred almost constantly.'
    },
    {
        id: 2.4,
        url: require("../component/Dashboard/image/italifood-4.jpg"),
        rate: '700',
        title: 'Ratatouille',
        quantity: '2 serve',
        star: 4.5,
        titlename: 'ItalianFood',
        titleId: 2,
        description: 'Traditional French Ratatouille is an easy French side dish that consists of stewed vegetables: eggplant, zucchini, onions, yellow squash, bell peppers garlic, fresh tomatoes and herbs.'
    },
    {
        id: 2.5,
        url: require("../component/Dashboard/image/italifood-5.jpg"),
        rate: '200',
        title: 'Tiramisu',
        quantity: '1 serve',
        star: 4.5,
        titlename: 'ItalianFood',
        titleId: 2,
        description: 'Tiramisù is a velvety mélange of savoiardi cookies dipped in an espresso, layered with delicately sweetened whipped eggs and mascarpone cheese, and topped with a dusting of cocoa powder.'
    },
    {
        id: 2.6,
        url: require("../component/Dashboard/image/italifood-6.jpg"),
        rate: '439',
        title: 'Frittata',
        quantity: '2 serve',
        star: 4.5,
        titlename: 'ItalianFood',
        titleId: 2,
        description: 'Frittata is an egg-based Italian dish similar to an omelette or crustless quiche or scrambled eggs, enriched with additional ingredients such as meats, cheeses, or vegetables. The word frittata is Italian and roughly translates to "fried".'
    },
    {
        id: 2.7,
        url: require("../component/Dashboard/image/Italifood-7.png"),
        rate: '639',
        title: 'Foccacia',
        quantity: '1 piece',
        star: 4.5,
        titlename: 'ItalianFood',
        titleId: 2,
        description: 'Focaccia is made from flour, oil, water, yeast, and salt, like pizza dough. However, it has more yeast than pizza dough, which allows it to rise more and make a fluffier, bread-like loaf. People love focaccia because of its smooth texture and taste.'
    },
    {
        id: 2.8,
        url: require("../component/Dashboard/image/italifood-8.jpg"),
        rate: '239',
        title: 'Pizza',
        quantity: '1 serve',
        star: 4.5,
        titlename: 'ItalianFood',
        titleId: 2,
        description: "With real italian pizza, you will find homemade sauce made from freshly peeled tomatoes and a blend of savory, complimenting herbs. You will also notice that authentic Italian pizza doesn't combine the toppings and sauce to be cooked together. They simply layer the sauce along the crus"
    },


    {
        id: 3.1,
        url: require("../component/Dashboard/image/kor-1.jpg"),
        rate: '250',
        title: 'Tteokbokki',
        quantity: '1 Serve',
        star: 4.5,
        description: "Tteokbokki is a Korean street food snack made primarily of chewy rice cakes and fiery, funky gochujang chili paste. In Lonely Planet's The World's Best Spicy Food, the cakes are tossed with slices of fried eomuk fish cake, cabbage, scallions, and garlic.",
        fakerate: 900,
        titlename: 'korean',
        titleId: 3
    },
    {
        id: 3.2,
        url: require("../component/Dashboard/image/kor-2.jpg"),
        rate: '400',
        title: 'Sundubu jjigae',
        quantity: '1 Serve',
        star: 4.5,
        description: "Sundubu jjigae is a Korean stew made with soft (uncurdled) tofu as a highlight ingredient. There are a few different ways to make sundubu jjigae using different ingredients (e.g. kimchi, minced pork and seafood) but by far my favorite version is the seafood version known as Haemul Sundubu Jjigae (해물 순두부 찌개).  You can really taste the refreshing and clear tasting soup.",
        titlename: 'korean',
        titleId: 3
    },
    {
        id: 3.3,
        url: require("../component/Dashboard/image/kor-3.jpg"),
        rate: '450',
        title: 'Jjin-mandu',
        quantity: '1 Serve',
        star: 4.5,
        description: "Jjin-mandu (찐만두) is steamed, either in a traditional bamboo steamer or modern versions. Gullin-mandu (굴린만두), also called gulmandu, is a variety of mandu in a ball shape without a covering. It is mainly eaten in summer. Wang mandu (왕만두) is a bun stuffed with pork and vegetables, similar to the Chinese baozi.",
        titlename: 'korean',
        titleId: 3
    },
    {
        id: 3.4,
        url: require("../component/Dashboard/image/kor-4.jpg"),
        rate: '400',
        title: 'Kimchi fried rice',
        quantity: '1 Serve',
        star: 4.5,
        description: "Kimchi fried rice or kimchi-bokkeum-bap (김치볶음밥) is a variety of bokkeum-bap (fried rice), a popular dish in South Korea. Kimchi fried rice is made primarily with kimchi and rice, along with other available ingredients, such as diced vegetables or meats like spam.",
        titlename: 'korean',
        titleId: 3
    },
    {
        id: 3.5,
        url: require("../component/Dashboard/image/kor-5.jpg"),
        rate: '450',
        title: 'Kimbap',
        quantity: '5 pieces',
        star: 4.5,
        description: "Kimbap is a Korean dish made from cooked rice and ingredients such as vegetables, fish, and meats that are rolled in gim (김)—dried sheets of seaweed—and served in bite-sized slices. The origins of gimbap are debated.",
        titlename: 'korean',
        titleId: 3
    },
    {
        id: 3.6,
        url: require("../component/Dashboard/image/kor-6.png"),
        rate: '150',
        title: 'Hobakjuk',
        quantity: '1 Serve',
        star: 4.5,
        description: "Hobak-juk (호박죽) or pumpkin porridge is a variety of Korean porridge, or juk, made with pumpkin and glutinous rice flour. It is a smooth and naturally sweet porridge that is traditionally served to recovering patients or the elderly.",
        titlename: 'korean',
        titleId: 3
    },
    {
        id: 3.7,
        url: require("../component/Dashboard/image/kor-7.jpg"),
        rate: '380',
        title: 'Korean fried chicken',
        quantity: '1 Serve',
        star: 4.5,
        description: "Korean fried chicken is crunchy, crispy, and covered in various sauces of your choosing. Some flavours are spicy, while others are covered in delicious umami sesame and soy sauce flavours, and some in a sweet sauce.",
        titlename: 'korean',
        titleId: 3
    },

]


export default Food